<template lang="pug">
.image-selector
  .dropbox(ref='dropbox' :class='{ drag: isDragging }')
    UploadButton.pa-0(:title='$t("selectOrDrag")' block accept='image/*' :fileChangedCallback='fileChanged' v-if='!value')
      template(slot='icon-left'): v-icon(left small) fas fa-upload
    .px-2.pb-4(v-if='value')
      v-card(flat max-height='150' max-width='150')
        v-system-bar(color='primary' lights-out dark)
          a.red--text(@click='removeFile')
            v-icon(color='red') close
            small(v-t='"remove"')
          v-spacer
          a(:href='value' v-if='!size' download :title='$t("downloadImage")'): v-icon(small) save_alt
        v-img(:src='value' :lazy-src='lazySrc' contain max-height='150' max-width='150')
          template(slot='placeholder'): Loader
          v-layout(fill-height align-center justify-center ma-0)
            .show-image-btn
              v-dialog(max-width=500 max-hegiht=500)
                v-btn(icon dark large slot='activator' :title='$t("viewImage")'): v-icon(small) fas fa-eye
                v-card
                  v-img(:src='value' :lazy-src='lazySrc' contain)
</template>

<script>
import lrz from 'lrz'
import Loader from '@/components/Loader.vue'
import UploadButton from 'vuetify-upload-button'

export default {
  name: 'ImageSelector',
  data () {
    this.lazySrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM8UQ8AAhUBSQV8WJQAAAAASUVORK5CYII='
    return {
      size: null,
      isDragging: false,
    }
  },
  props: {
    value: {
      type: String,
    },
    max: {
      type: Number,
      default: 640,
    },
  },
  mounted () {
    const dropbox = this.$refs.dropbox
    dropbox.addEventListener('dragenter', this.onDrag, false)
    dropbox.addEventListener('dragover', this.onDrag, false)
    dropbox.addEventListener('drop', this.onDrop, false)
    dropbox.addEventListener('dragleave', this.onLeave, false)
  },
  methods: {
    // 選擇新的圖片檔案
    fileChanged (file) {
      lrz(file, { width: this.max, height: this.max })
        .then(result => {
          const sizeKb = result.file.size / 1000
          if (sizeKb < 1000) {
            this.$emit('input', result.base64)
            this.size = this.$t('sizeAfterCompressed', { size: sizeKb.toFixed(1), len: result.base64Len })
          } else {
            alert('The compressed image is still too big!')
          }
        })
        .catch(e => alert('圖片讀取失敗! 請嘗試其他檔案'))
    },
    // 移除圖片
    removeFile () {
      this.$emit('input', null)
    },
    onDrag (e) {
      e.stopPropagation()
      e.preventDefault()
      this.isDragging = true
    },
    onDrop (e) {
      e.stopPropagation()
      e.preventDefault()
      const dt = e.dataTransfer
      this.fileChanged(dt.files[0])
      this.isDragging = false
    },
    onLeave (e) {
      this.isDragging = false
    },
  },
  components: {
    Loader,
    UploadButton,
  },
}
</script>

<style scoped lang='sass'>
$duration: .3s

.show-image-btn
  display: flex
  justify-content: center
  align-items: center
  height: 100%
  width: 100%
  opacity: 0
  transition: opacity $duration
  .v-icon
    transition: transform $duration
    transform: scale(.5)
  &:hover
    opacity: 1
    background-color: rgba(black, .5)
    cursor: pointer
    .v-icon
      transform: none

.dropbox
  transition: all $duration
  width: 100%
  &.drag
    background-color: rgba(#ddd, .5)

.upload-button
  input
    width: 0
</style>

<i18n src="@/lang/components/imageSelector.json"></i18n>
